import { correctBorderRadius } from "../../external/.pnpm/framer-motion@12.25.0/external/framer-motion/dist/es/projection/styles/scale-border-radius.mjs";
import { correctBoxShadow } from "../../external/.pnpm/framer-motion@12.25.0/external/framer-motion/dist/es/projection/styles/scale-box-shadow.mjs";
const defaultScaleCorrector = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
export {
  defaultScaleCorrector
};
